import { Interpolate, ClanName } from '@wg/wows-react-uikit';

import { REQUEST_STATUSES } from '~/constants';
import { isoToFormattedLocalDate, isoToFormattedLocalTime } from '~/helpers/datetime';
import { t } from '~/helpers/localization';

import styles from './ApplicationsClanMemberTableItem.scss';

import type { IMemberApplication } from '~/Actions/ActionApplications';
import type { ICurrentAccountState } from '~/store/slices/currentAccountSlice';

interface ApplicationsNonClanMemberTableItemTooltipProps {
  currentAccount: ICurrentAccountState;
  application: IMemberApplication;
}

const ApplicationsNonClanMemberTableItemTooltip = ({
  currentAccount,
  application,
}: ApplicationsNonClanMemberTableItemTooltipProps) => {
  const { status, created_at, expires_at, updated_at } = application;
  const { inClanCooldownTill } = currentAccount || {};

  if (inClanCooldownTill) {
    return (
      <div>
        <Interpolate
          className={styles.tooltipParagraph}
          useDangerouslySetInnerHTML={true}
          str={t('Вы отправили заявку на вступление в клан %(date)s&nbsp;в&nbsp;%(time)s.')}
          date={isoToFormattedLocalDate(created_at)}
          time={isoToFormattedLocalTime(created_at)}
        />
        <Interpolate
          className={styles.tooltipParagraph}
          useDangerouslySetInnerHTML={true}
          str={t('Вы недавно покинули клан. Вступление в клан станет доступно %(date)s&nbsp;%(time)s.')}
          date={isoToFormattedLocalDate(inClanCooldownTill)}
          time={isoToFormattedLocalTime(inClanCooldownTill)}
        />
        <Interpolate
          useDangerouslySetInnerHTML={true}
          str={t('Время для принятия решения по заявке истекает %(date)s&nbsp;в&nbsp;%(time)s.')}
          date={isoToFormattedLocalDate(expires_at)}
          time={isoToFormattedLocalTime(expires_at)}
        />
      </div>
    );
  }

  if (status === REQUEST_STATUSES.EXPIRED) {
    return (
      <div>
        <Interpolate
          className={styles.tooltipParagraph}
          useDangerouslySetInnerHTML={true}
          str={t('Время для принятия решения истекло %(date)s&nbsp;в&nbsp;%(time)s.')}
          date={isoToFormattedLocalDate(expires_at)}
          time={isoToFormattedLocalTime(expires_at)}
        />
        <Interpolate
          useDangerouslySetInnerHTML={true}
          str={t('Вы отправили заявку %(date)s&nbsp;в&nbsp;%(time)s.')}
          date={isoToFormattedLocalDate(created_at)}
          time={isoToFormattedLocalTime(created_at)}
        />
      </div>
    );
  }

  if (status === REQUEST_STATUSES.ACCEPTED) {
    const { name, tag, color } = application.clan;

    return (
      <div>
        <Interpolate
          useDangerouslySetInnerHTML={true}
          className={styles.tooltipParagraph}
          str={t('Клан %(clanName)s одобрил заявку %(date)s&nbsp;в&nbsp;%(time)s')}
          clanName={<ClanName clanTag={tag} clanName={name} clanColor={color} />}
          date={isoToFormattedLocalDate(updated_at)}
          time={isoToFormattedLocalTime(updated_at)}
        />
        <Interpolate
          useDangerouslySetInnerHTML={true}
          str={t('Вы отправили заявку %(date)s&nbsp;в&nbsp;%(time)s.')}
          date={isoToFormattedLocalDate(created_at)}
          time={isoToFormattedLocalTime(created_at)}
        />
      </div>
    );
  }

  if (status === REQUEST_STATUSES.DECLINED) {
    const { name, tag, color } = application.clan;

    return (
      <div>
        <Interpolate
          className={styles.tooltipParagraph}
          useDangerouslySetInnerHTML={true}
          str={t('Клан %(clanName)s отклонил заявку %(date)s&nbsp;в&nbsp;%(time)s')}
          clanName={<ClanName clanTag={tag} clanName={name} clanColor={color} />}
          date={isoToFormattedLocalDate(updated_at)}
          time={isoToFormattedLocalTime(updated_at)}
        />
        <Interpolate
          useDangerouslySetInnerHTML={true}
          str={t('Вы отправили заявку %(date)s&nbsp;в&nbsp;%(time)s.')}
          date={isoToFormattedLocalDate(created_at)}
          time={isoToFormattedLocalTime(created_at)}
        />
      </div>
    );
  }

  return (
    <div>
      <Interpolate
        className={styles.tooltipParagraph}
        useDangerouslySetInnerHTML={true}
        str={t('Вы отправили заявку на вступление в клан %(date)s&nbsp;в&nbsp;%(time)s.')}
        date={isoToFormattedLocalDate(created_at)}
        time={isoToFormattedLocalTime(created_at)}
      />
      <Interpolate
        useDangerouslySetInnerHTML={true}
        str={t('Время для принятия решения по заявке истекает %(date)s&nbsp;в&nbsp;%(time)s.')}
        date={isoToFormattedLocalDate(expires_at)}
        time={isoToFormattedLocalTime(expires_at)}
      />
    </div>
  );
};

export default ApplicationsNonClanMemberTableItemTooltip;
